import { createContext } from 'react';
import { stores } from './index';
import { IStores } from './createStores';

export const StoresContext = createContext<IStores>(stores);
